export default __webpack_public_path__ + "static/media/lightningsteel.41cea338.png";